import React from "react";

import { Avatar, Box, Typography } from "@braintrust/braintrust-ui-components";

import type { GetPublicInvitationDetailsResponse } from "../../api";

import { InvitedByUserToJob } from "./invited-by-user-to-job";

import style from "./style.module.scss";

type InvitedByUserProps = {
  publicInvitationDetails: GetPublicInvitationDetailsResponse;
};

export const InvitedByUser: React.FC<InvitedByUserProps> = ({
  publicInvitationDetails,
}) => {
  return (
    <>
      <InvitedByUserToJob publicInvitationDetails={publicInvitationDetails} />
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Avatar
          sx={{ height: 28, width: 28, bgcolor: "none !important" }}
          alt={publicInvitationDetails.first_name}
          textSize="small"
          color={
            publicInvitationDetails.account_type === "freelancer"
              ? "dark-blue"
              : "medium-violet"
          }
          src={publicInvitationDetails}
        />
        <Typography component="span" variant="label" className={style.badge}>
          {publicInvitationDetails.first_name} invited you to join!
        </Typography>
      </Box>
    </>
  );
};

export const isInvitationToOpenedJob = (
  invitation: GetPublicInvitationDetailsResponse,
): invitation is Omit<GetPublicInvitationDetailsResponse, "job"> &
  Required<Pick<GetPublicInvitationDetailsResponse, "job">> => {
  return !!invitation?.job?.is_open;
};
